// Bloc HP "Changez le tamis, pas la raquette" (sections/systeme-cadre-tamis.liquid)
// — lecture de la video uniquement quand elle entre dans le viewport (le
// bloc est sous la ligne de flottaison), et jamais si l'utilisateur a
// active "reduire les animations" (prefers-reduced-motion). Dans les 2 cas
// ou la video ne se lance pas, le `poster` reste affiche comme visuel fixe.
(function () {
  var video = document.querySelector('.cadre-tamis-top__video');
  if (!video) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var source = video.querySelector('source[data-src]');
  if (!source) return;

  function loadAndPlay() {
    source.src = source.getAttribute('data-src');
    video.load();
    video.play().catch(function () {
      // Autoplay bloque (rare avec muted+playsinline) : le poster reste
      // affiche, aucune erreur visible pour l'utilisateur.
    });
  }

  if (!('IntersectionObserver' in window)) {
    loadAndPlay();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadAndPlay();
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.25 }
  );
  observer.observe(video);
})();
